import { render, staticRenderFns } from "./filterChips.vue?vue&type=template&id=cb6e4b3e"
import script from "./filterChips.vue?vue&type=script&lang=js"
export * from "./filterChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports